import React from 'react';
import { connect } from 'react-redux';

let Flash = ({ message, setFlashMessageNull, success }) => {
  setTimeout(() => { setFlashMessageNull() }, 8000);
  if (success) {
    return(
      <p className="alert alert-success alert-feedback"  onClick={()=> setFlashMessageNull()}>{message}</p>
    )
  }
  return(
    <p className="alert alert-failure alert-feedback"  onClick={()=> setFlashMessageNull()}>{message}</p>
  )
};
const mapStateToProps = (state) => {
  return {
    success: state.Flash.success
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFlashMessageNull: () => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE_NULL',
        }
      );
    },
  }
}

Flash = connect(
  mapStateToProps,
  mapDispatchToProps
)(Flash);
export default Flash;



// WEBPACK FOOTER //
// ./src/components/Flash/Flash.js